import { useState } from 'react'

import Header from '@components/Header'
import { Tab, Tabs } from '@mui/material'
import { useQuery } from '@tanstack/react-query'

import { PackagesList } from './PackagesList'
import auditApi from './api'
import { Container } from './index.styles'

enum Sides {
  frontend = 'frontend',
  backend = 'backend',
}

enum Services {
  search = 'search',
  userContent = 'user-content',
  alertsHistory = 'alerts-history',
  reports = 'reports',
}

export const Audit = () => {
  const [selectedSide, setSelectedSide] = useState<Sides>(Sides.frontend)
  const [selectedService, setSelectedService] = useState(Services.search)

  const { data: packages, isLoading } = useQuery({
    queryKey: [auditApi.fetchAuditData.key, selectedSide, selectedService],
    queryFn: () => auditApi.fetchAuditData.fn({ service: selectedService, side: selectedSide }),
  })

  const handleChangeSide = (event: React.SyntheticEvent, newValue: string) => {
    setSelectedSide(newValue as Sides)
    if (newValue === Sides.backend) {
      setSelectedService(Services.search)
    }
  }

  const handleChangeService = (event: React.SyntheticEvent, newValue: string) => {
    setSelectedService(newValue as Services)
  }

  return (
    <div>
      <Header />
      <Container>
        <div>
          <Tabs value={selectedSide} onChange={handleChangeSide} aria-label="basic tabs example">
            <Tab label="Frontend" value={Sides.frontend} />
            <Tab label="Backend" value={Sides.backend} />
          </Tabs>
          {selectedSide === Sides.backend && (
            <Tabs value={selectedService} onChange={handleChangeService} aria-label="basic tabs example">
              <Tab label="Search" value={Services.search} />
              <Tab label="User Content" value={Services.userContent} />
              <Tab label="Alerts History" value={Services.alertsHistory} />
              <Tab label="Reports" value={Services.reports} />
            </Tabs>
          )}
        </div>
        {!isLoading && packages && !!Object.keys(packages).length && <PackagesList packages={packages} />}
      </Container>
    </div>
  )
}
